<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-progress-linear v-if="$apollo.loading" indeterminate />
      <highcharts v-if="engagementPerTeam" :options="engagementPerTeamReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import { ENGAGEMENT_PER_TEAM_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "TeamEngagement",
  props: {
    title: {
      type: String,
      default: "Engagement per team",
    },
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    gymBranch: {
      type: [Number, String],
    },
    team: {
      type: [Number, String],
    },
  },
  data() {
    return {
      engagementPerTeam: null,
    };
  },
  computed: {
    engagementPerTeamReport() {
      let series = this.engagementPerTeam.map((x) => {
        return {
          name: x["cohort"],
          data: x["engagement"].map((c) => [c["actionDate"], parseInt(c["userCount"])]),
        };
      });
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: this.title,
        },
        xAxis: {
          categories: this.engagementPerTeam[0].engagement.map((x) => x["actionDate"]),
        },
        yAxis: {
          title: {
            text: "# of actions",
          },
        },
        credits: {
          enabled: false,
        },

        series: series,
      };
    },
  },
  apollo: {
    engagementPerTeam: {
      query: ENGAGEMENT_PER_TEAM_QUERY,
      fetchPolicy: "network-only",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          gymBranch: this.gymBranch,
          team: this.team,
        };
      },
      skip() {
        return !this.team;
      },
    },
  },
};
</script>
